import { useMemo } from 'react'
import { Theme as HeroTheme } from '@conexasaude/styles'
import { ChipProps, isVariant, IUseStateStyles } from './types'

export interface ValidatedProps {
  variant: ChipProps['variant']
}
export interface PropsToValidate {
  propVariant: ChipProps['variant']
}
export const useValidateState = ({
  propVariant,
}: PropsToValidate): ValidatedProps => {
  const variant = useMemo(() => {
    if (!isVariant(propVariant)) {
      if (propVariant) {
        console.warn(
          'The provided variant property is not a valid variant. A default value will be used.',
        )
      }
      return 'main'
    }
    return propVariant
  }, [propVariant])

  return { variant }
}

export const useStateStyles: IUseStateStyles = ({
  checked,
  disabled,
  styles,
  overrides,
}) => {
  const activeStyles = useMemo(() => {
    if (checked) return [styles.checked, overrides?.checked]

    return []
  }, [checked, styles.checked, overrides?.checked])

  const disabledStyles = useMemo(() => {
    if (disabled) return [styles.disabled, overrides?.disabled]

    return []
  }, [disabled, styles.disabled, overrides?.disabled])

  return { activeStyles, disabledStyles }
}

export const themeToStyle = (
  themeVariant: 'main' | 'outline',
  themeColors: HeroTheme['colors'],
): {
  outline: string
  border: string
  background: string
  label: string
  active: {
    borderColor: string
    background: string
    label: string
  }
  disabled: {
    background: string
    borderColor: string
    label: string
  }
  hover: {
    label: string
  }
} => {
  const variantDict = {
    main: {
      outline: 'none',
      border: 'none',
      background: themeColors.neutral[100],
      label: themeColors.neutral[700],
      active: {
        borderColor: '',
        background: themeColors.primary[100],
        label: themeColors.primary[500],
      },
      disabled: {
        background: themeColors.extra.disabled_bg,
        borderColor: themeColors.extra.disabled_bg,
        label: themeColors.extra.disabled_font,
      },
      hover: {
        label: themeColors.primary[500],
      },
    },
    outline: {
      outline: 'none',
      border: `1px solid ${themeColors.neutral[100]}`,
      background: 'transparent',
      label: themeColors.neutral[700],
      active: {
        borderColor: themeColors.primary[500],
        background: 'transparent',
        label: themeColors.primary[500],
      },
      disabled: {
        background: 'transparent',
        borderColor: themeColors.extra.disabled_bg,
        label: themeColors.extra.disabled_font,
      },
      hover: {
        label: themeColors.primary[500],
      },
    },
  }
  return variantDict[themeVariant]
}
